import { Route, Routes } from 'react-router-dom';
import { AffiliateUsersPage } from './AffiliateUsersPage';
import { AffiliateUserDetailsPage } from './AffiliateUserDetailsPage';

export const AffiliateUserPageRoot = () => (
  <Routes>
    <Route path='/:userID' element={<AffiliateUserDetailsPage />} />
    <Route path='*' element={<AffiliateUsersPage />} />
  </Routes>
);
